/**
 *
 * input field component with label (url: /create-account)
 *
 * @author chargoyao
 * @property style {object} the styles of the element.
 * @property labelStyle {object} the styles of label.
 * @property borderColor {string} input's border color.
 * @property inputStyle {object} input element style.
 * @property inputType {string} input type.
 * @property ifHasBorder {boolean} if add border
 * @property hintText {string} placeholder text.
 * @property labelTitle {string} label title.
 * @property initValue {string} init value
 * @property onBlur {function}
 * @function onChange {function} call function is fired when the textfield's value changes, this callback will pass two params: one is event object second is the input value.
 * @property toolTipContainerStyle {object} tool tip container style
 * @property toolTipContainerBorderColor {style} tool tip container border color
 * @property toolTipContent {string} tip content, if you do not assign this props, tooltip container will be hidden.
 * @property children , be supported.
 * @property inputContainerId input container id
 * @property ifRequireField if true, lableTit will show `*`
 * @property inputContainerClassName input container class name
 *
 */
import React, { Component } from "react";
import PropTypes from "prop-types";
import isEmpty from "lodash/isEmpty";

class InputField extends Component {
  getRootStyle(rootInitStyle = this.props.rootInitStyle) {
    const rootStyle = this.props.style;
    return {
      ...rootInitStyle,
      ...rootStyle,
    };
  }
  getLabelStyle(labelInitStyle = this.props.labelStyle) {
    const labelStyle = this.props.labelStyle;

    return {
      ...labelInitStyle,
      ...labelStyle,
    };
  }
  getInputStyle(inputInitStyle = this.props.inputInitStyle) {
    const inputStyle = this.props.inputStyle;

    return {
      ...inputInitStyle,
      ...inputStyle,
    };
  }
  getTooltipStyle(toolTipInitStyle = this.props.toolTipInitStyle) {
    const tooltipStyle = this.props.toolTipContainerStyle;
    // add container border
    toolTipInitStyle.border = `1px solid ${this.props
      .toolTipContainerBorderColor || this.props.initTooltipBorderColor}`;

    return {
      ...toolTipInitStyle,
      ...tooltipStyle,
    };
  }
  handleOnChange(e, value) {
    if (typeof this.props.onChange !== "undefined") {
      this.props.onChange(e, value);
    }
    // if (typeof this.props.toolTipContent === 'undefined' && typeof this.props.children === 'undefined') {
    //   this.refs.tooltipBox.style.display = 'none';
    // } else {
    //   this.refs.tooltipBox.style.display = 'block';
    // }
  }
  handleInputFocus(e) {
    // if toolTipContent value is null , hidden tooltip
    if (
      typeof this.props.toolTipContent === "undefined" &&
      typeof this.props.children === "undefined"
    ) {
      this.refs.tooltipBox.style.display = "none";
    } else {
      this.refs.tooltipBox.style.display = "block";
    }

    let toolTipRect = this.refs.tooltipBox.getClientRects();
    if (toolTipRect.length > 0) {
      // computed top value  30 is the padding value
      this.refs.tooltipBox.style.top = `-${(toolTipRect[0].height - 30) / 2}px`;
      // computed right value
      this.refs.tooltipBox.style.right = `-${toolTipRect[0].width + 20}px`;
    }
    if (this.props.maskInput && typeof this.props.maskInput === "function") {
      this.refs.inputRef.value = this.refs.hiddenRef.value;
    }

    if (this.props.initValue && isEmpty(this.refs.hiddenRef.value)) {
      this.refs.inputRef.value = this.props.initValue;
    }
  }
  handleInputBlur(e, value) {
    this.refs.tooltipBox.style.display = "none";
    if (typeof this.props.handleOnBlur === "function") {
      this.props.handleOnBlur(e, value);
    }
    if (this.props.maskInput && typeof this.props.maskInput === "function") {
      this.refs.hiddenRef.value = value;
      this.refs.inputRef.value = this.props.maskInput(value);
    }
  }
  render() {
    return (
      <div className="common-input clearfix" style={this.getRootStyle()}>
        <p style={this.getLabelStyle()}>
          {this.props.labelTitle}
          <em
            style={{
              display: this.props.ifRequireField ? "inline-block" : "none",
              color: "red",
            }}
          >
            *
          </em>
        </p>
        <div
          className={`input-border ${this.props.inputContainerClassName || ""}`}
          id={this.props.inputContainerId}
          style={{
            position: "relative",
            height: "33px",
            border: this.props.ifHasBorder
              ? "none"
              : `1px solid ${this.props.borderColor ||
                  this.props.borderInitStyle}`,
          }}
        >
          {/*tooltip*/}
          <div
            className="input-tooltip-wrapper"
            style={{
              display:
                typeof this.props.toolTipContent === "undefined"
                  ? "none"
                  : "block",
            }}
          >
            <div
              className="input-tooltip"
              style={this.getTooltipStyle()}
              ref="tooltipBox"
            >
              <div
                style={{
                  width:
                    this.props.labelTitle === "Confirm Password*"
                      ? "202px"
                      : "",
                  height:
                    this.props.labelTitle === "Confirm Password*" ? "40px" : "",
                  lineHeight:
                    this.props.toolTipContent === "Enter Confirm Password."
                      ? "40px"
                      : "",
                }}
              >
                {this.props.toolTipContent}
              </div>
              {this.props.children}
              <i
                style={{
                  position: "absolute",
                  width: "0.6em",
                  height: "0.6em",
                  left: "-0.39em",
                  top: "50%",
                  marginTop: "-0.3em",
                  border: `1px solid ${this.props.toolTipContainerBorderColor ||
                    this.props.initTooltipBorderColor}`,
                  borderTop: "none",
                  borderRight: "none",
                  background: "white",
                  transform: "rotate(45deg)",
                }}
              />
            </div>
          </div>
          <input
            style={{ display: "none" }}
            type={this.props.inputType || "text"}
          />
          <input type="hidden" ref="hiddenRef" />
          <input
            maxLength={this.props.maxLength ? this.props.maxLength : 100}
            type={this.props.inputType || "text"}
            defaultValue={this.props.initValue}
            style={this.getInputStyle()}
            autocomplete={"aa-" + this.props.inputContainerId}
            ref="inputRef"
            onChange={e => this.handleOnChange(e, this.refs.inputRef.value)}
            placeholder={this.props.hintText}
            onFocus={e => this.handleInputFocus(e)}
            onBlur={e => this.handleInputBlur(e, this.refs.inputRef.value)}
            onKeyDown={this.props.onKeyDown}
            key={this.props.labelTitle}
          />
        </div>
      </div>
    );
  }
}

InputField.defaultProps = {
  rootInitStyle: {
    marginBottom: "0.8em",
    position: "relative",
  },
  labelStyle: {
    color: "black",
    fontSize: "16px",
  },
  borderInitStyle: "#B1B0B0",
  inputInitStyle: {
    border: "none",
    height: "25px",
    width: "98%",
    paddingLeft: "10px",
    fontSize: "16px",
    color: "black",
  },

  toolTipInitStyle: {
    position: "absolute",
    display: "none",
    top: "0",
    right: "-14em",
    padding: "15px",
    borderRadius: "6px",
    maxWidth: "18em",
    background: "white",
  },
  initTooltipBorderColor: "#bdbaba",
};

InputField.propTypes = {
  labelTitle: PropTypes.string.isRequired,
};

export default InputField;



// WEBPACK FOOTER //
// ./src/components/framework/InputField/InputField.jsx